export default {
  name: "Typo3",
  data: () => ({}),
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    }
  }
};
